const navbar = {
  packages: "Pacchetti", // translated
  experiences: "Esperienze", // translated
  close: "Chiudere", // translated
  pricing: "Prezzi", // translated
  dashboard: "Pannello di controllo", // translated
  hotDeals: "Grandi affari", // translated
  hotelPackages: "Pacchetti alberghieri", // translated
};


export default navbar;
